import Image from 'next/legacy/image'
import logoVertical from '@/public/logo-vertical.png'
import Button from '@/components/Button/Button'
import { Stack, Clamp, Row } from '@christiankaindl/lyts'
import { type FC } from 'react'
import * as styles from './Footer.css'
import { Instagram, Linkedin } from 'lucide-react'
import Link from 'next/link'

const Footer: FC = function () {
  return (
    <Clamp
      asChild
      clamp='900px'
      className={styles.root}
      // xAlign='center'
    >
      <footer>
        <Row expandChildren wrap gap={3} yAlign='start' xAlign='center'>
          <Stack gap={0.25} xAlign='center'>
            <Image
              src={logoVertical}
              width={logoVertical.width / 2}
              height={logoVertical.height / 2}
              alt='Logo'
            />
          </Stack>
          <Row gap={2} wrap yAlign='start' xAlign='center'>
            <Stack gap={0.5}>
              <Link href='/amiga' style={{ paddingLeft: 9 }}>
                <b>AmigaAI</b>
              </Link>
              <Button href='/amiga/regulatory-monitoring' variant='flat' size='small'>
                Regulatory Monitoring
              </Button>
              <Button href='/amiga/judikatur-monitoring' variant='flat' size='small'>
                Judikatur Monitoring
              </Button>
              <Button href='/amiga/judikatur-monitoring#summary' variant='flat' size='small'>
                AmigaAI Summary
              </Button>
              <Button href='/amiga/api#search' variant='flat' size='small'>
                Search API
              </Button>
              <Button href='/amiga/api#data' variant='flat' size='small'>
                Data API
              </Button>
              <Button href='/amiga/api#summary' variant='flat' size='small'>
                Summary API
              </Button>
            </Stack>

            <Stack gap={0.5}>
              <Link href='/enterprise' style={{ paddingLeft: 9 }}>
                <b>Enterprise Lösungen</b>
              </Link>
              <Button href='/enterprise#iks-integration' variant='flat' size='small'>
                IKS Integrationen
              </Button>
              <Button href='/enterprise#fine-tuning' variant='flat' size='small'>
                Legal LLM
              </Button>
              <Button href='/enterprise#chat' variant='flat' size='small'>
                Chat-Lösungen
              </Button>
              <Button href='/enterprise#document-generation' variant='flat' size='small'>
                Dokumentgenerierung
              </Button>
              <Button href='/enterprise#fine-tuning' variant='flat' size='small'>
                Fine-tuning
              </Button>
              <Button href='/enterprise#semantic-search' variant='flat' size='small'>
                Semantische Suche
              </Button>
            </Stack>

            <Stack gap={0.5}>
              <span style={{ paddingLeft: 9 }}>
                <b>Plattform</b>
              </span>
              <Button href='/bundesrecht' variant='flat' size='small'>
                Bundesrecht
              </Button>
              <Button href='/landesrecht' variant='flat' size='small'>
                Landesrecht
              </Button>
              <Button href='/judikatur' variant='flat' size='small'>
                Judikatur
              </Button>
              <hr style={{ marginLeft: 9 }} />
              <Button href='/team' variant='flat' size='small'>
                Team
              </Button>
              <Button href='/jobs' variant='flat' size='small'>
                Jobs
              </Button>
            </Stack>
            <Stack gap={0.5}>
              <Button href='https://www.linkedin.com/company/gesetzefinden' variant='flat' size='small'>
                <Linkedin size={16} />
                LinkedIn
              </Button>
              <Button href='https://www.instagram.com/gesetzefinden.at/' variant='flat' size='small'>
                <Instagram size={16} />
                Instagram
              </Button>
              <hr style={{ marginLeft: 9 }} />
              <Button href='/agb' variant='flat' size='small' title='Allgemeine Geschäftsbedingungen'>
                AGB
              </Button>
              <Button href='/datenschutz' variant='flat' size='small'>
                Datenschutzerklärung
              </Button>
              <Button href='/impressum' variant='flat' size='small'>
                Impressum
              </Button>
              <Button href='/haftungsausschluss' variant='flat' size='small'>
                Haftungsausschluss
              </Button>
            </Stack>
          </Row>
        </Row>
      </footer>
    </Clamp>
  )
}

export default Footer
